export default "__VITE_ASSET__brzYyrbJ__"